export function initBrandScroller() {
  const container = document.querySelector('.brand-images-container');
  if (!container) return;

  // Only enable auto-scroll on mobile devices
  if (window.innerWidth > 768) return;

  const images = container.querySelectorAll('img');
  if (images.length === 0) return;

  // Clone images for seamless infinite scroll
  images.forEach(img => {
    const clone = img.cloneNode(true);
    container.appendChild(clone);
  });

  let scrollPosition = 0;
  const scrollSpeed = 0.5; // pixels per frame
  let isPaused = false;

  function autoScroll() {
    if (isPaused) return;

    scrollPosition += scrollSpeed;
    container.scrollLeft = scrollPosition;

    // Reset position when we've scrolled through the original set
    const maxScroll = container.scrollWidth / 2;
    if (scrollPosition >= maxScroll) {
      scrollPosition = 0;
      container.scrollLeft = 0;
    }
  }

  // Start the auto-scroll animation
  let animationId = setInterval(autoScroll, 16); // ~60fps

  // Pause on user interaction
  let userInteractionTimeout;
  container.addEventListener('touchstart', () => {
    clearInterval(animationId);
    clearTimeout(userInteractionTimeout);
  });

  container.addEventListener('touchend', () => {
    scrollPosition = container.scrollLeft;
    userInteractionTimeout = setTimeout(() => {
      animationId = setInterval(autoScroll, 16);
    }, 3000); // Resume after 3 seconds of no interaction
  });

  // Clean up on resize
  window.addEventListener('resize', () => {
    if (window.innerWidth > 768) {
      clearInterval(animationId);
    }
  });
}
